import React from "react";
import "../../assets/css/vendor.bundle.css";
import "../../assets/css/style.css";
import "../../assets/css/theme.css";
import TrendingViewChart from "../tradingview_chart/TradingViewChart";
import MediumWidget from "../medium_widget/MediumWidget";
import ForexCrossRatesWidget from "../forexcrossrates_widget/ForexCrossRatesWidget";
import Navbar from "../common/NavBar";
import Footer from "../common/Footer";
import { Helmet } from "react-helmet-async";

const Forex = () => {
    return (
        <div>
            <Helmet>
                <title>Forex</title>
            </Helmet>
            <div className="site-header header-s1 is-sticky">
                <Navbar />
                {/* Banner/Slider */}
                <div className="page-head section row-vm light has-bg-image">
                    <div className="imagebg bg-image-loaded" style={{ backgroundImage: `url(${require('../../assets/images/page-inside-bg.jpg')})` }}>
                        <img
                            src={require("../../assets/images/page-inside-bg.jpg")}
                            alt="page-head"
                        />
                    </div>
                    <div className="container">
                        <div className="row text-center">
                            <div className="col-md-12">
                                <h2>Forex</h2>
                                <div className="page-breadcrumb">
                                    <ul className="breadcrumb">
                                        <li>
                                            <a href="/">Markets</a>
                                        </li>
                                        <li className="active">
                                            <span>Forex</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* #end Banner/Slider */}
            </div>
            {/*Section */}
            <div className="section section-pad bg-grey">
                <div className="container">
                    <h2>
                        Trade Forex with AFC Trades
                    </h2>
                    <div class="gaps size-3x"></div>
                    <div className="row row-vm forex-p">
                        <div className="col-md-6">
                            <div className="text-block text-left">
                                <p>
                                    The international foreign exchange market is among the most dynamic, liquid, and fascinating marketplaces in the world.
                                    Hundreds of traders currently use AFC Trades, an award-winning London Forex broker that offers over 60 currency pairings in all
                                    major currencies 24/5. The US dollar (USD) is used as the base or counter currency in all major currencies. GBP/USD, EUR/USD,
                                    and USD/JPY are examples of majors.
                                    <br />
                                    <br />
                                    AFC Trades has persistently tight spreads, beginning as low as 0.0 pips. We've teamed up with some of
                                    the most well-known banking and non-banking institutions in order to ensure a large liquidity pool,
                                    so that you obtain the best market rates and the shortest possible latency order can be carried out.
                                </p>
                            </div>

                            {/* <div className="trendingview-chart res-m-bttm">
                                <TrendingViewChart />
                            </div> */}
                        </div>
                        <div className="col-md-6">
                            <div className="text-block text-left">
                                <h4>What are the advantages of trading forex?</h4>
                                <ul className="checkbox-list">
                                    <li>Spreads start at 0.0 pips.</li>
                                    <li>Leverage ratios of up to 30:1 are available.</li>
                                    <li>There are more than 60 currency pairs available.</li>
                                    <li>The Forex markets are open 24/5.</li>
                                    <li>Multilingual customer service that has won awards.</li>
                                    <li>There will be no price manipulation, requotes, or dealing desk.</li>
                                    <li>Take advantage of low-margin, low-cost trading.</li>
                                    <li>Equinix servers provide lightning-fast trade execution.</li>
                                    <li>24 hours a day, 5 days a week, you can enter and exit trades whenever you choose.</li>
                                    <li>Trading possibilities can be enhanced by trading in any path you anticipate the markets will go, whether short or long.</li>
                                    <li>With cutting-edge techniques, you have access to pre-open price movements and can predict market trends.</li>
                                </ul>

                            </div>

                            {/* <div className="trendingview-chart res-m-bttm">
                                <TrendingViewChart />
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
            {/*Section */}

            {/*Section */}
            <div className="section section-pad">
                <div className="container">
                    <h2>
                        What is Forex Trading and How Does It Work?
                    </h2>
                    <p>Purchasing one currency and selling another is the basis of forex trading.
                        Traders attempt to profit from price changes by predicting the likely trend of currency values through meticulous analysis.
                        For FX trading, there is no centralized exchange. Alternatively, it occurs digitally or online, between worldwide computer networks.
                        The market is open five days a week, 24 hours a day.

                    </p>
                </div>
            </div>
            {/*Section */}

            {/* Section */}
            {/* <div className="section section-pad">
                <div className="container">
                    <div className="row row-vm reverses">
                        <div className="col-md-6 res-m-bttm">
                            <MediumWidget />
                        </div>
                        <div className="col-md-5 col-md-offset-1">
                            <div className="text-block text-left">
                                <h2>
                                    Take a Look at
                                    <br />
                                    Forex Stock Chart
                                </h2>
                                <p>
                                    Ready to embark on your journey into the exciting world of Forex trading? Learn, trade, and grow with AFC Trades.
                                </p>
                                <p>
                                    Forex trading offers endless opportunities to trade global currency pairs. At AFC Trades, we provide a reliable platform with advanced tools to help you analyze trends and make informed trading decisions.
                                </p>
                                <a href="#" className="btn btn-alt">
                                    Get Started
                                </a>
                            </div>
                        </div>

                    </div>
                </div>
            </div> */}
            {/* Section */}

            {/*Section */}
            <div className="section section-pad bg-grey">
                <div className="container">
                    <h2>
                        Forex Spreads
                    </h2>
                    <div className="row">
                        <div className="col-md-10 col-md-offset-1">
                            <div className="trendingview-chart cross-rates">
                                <ForexCrossRatesWidget />
                            </div>
                        </div>
                    </div>
                    <div className="gaps size-2x"></div>
                    <div className="row text-center">
                        <div className="col-md-8 col-md-offset-2">
                            <div className="text-block">

                                <p>
                                    Looking to get started in the world of Forex Trading?
                                    Discover how to navigate the market, analyze trends, and make
                                    informed decisions. Cryptocurrency trading offers
                                    opportunities to capitalize on price movements, but it also
                                    requires a solid understanding of market dynamics. Whether
                                    you're new to crypto or an experienced trader, this chart can
                                    help you make better trading choices. Get insights into the
                                    latest market trends and price predictions.
                                </p>
                                <a href="#" className="btn btn-alt">
                                    Get Started
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* End Section */}
            {/*Section */}
            <div className="section section-pad">
                <div className="container">
                    <div className="row row-vm">
                        <div className="col-md-5 res-m-bttm">
                            <div className="text-block text-left">
                                <h2>
                                    Why Trade Forex with <span style={{ color: "#1c4b82" }}>Afc Trades</span>?
                                </h2>
                                <p>
                                    CryptoCoin is a cutting-edge platform designed to simplify
                                    cryptocurrency trading and management. Whether you're a
                                    seasoned trader or a newcomer, CryptoCoin empowers you to make
                                    the most of your digital assets.
                                </p>
                                <ul>
                                    <li>Competitive spreads from 0.6 pips on EUR/USD</li>
                                    <li>
                                        Powerful charting tools integral to the Forex.com
                                        intuitive platform
                                    </li>
                                    <li>You can trade Forex 24/5</li>
                                    <li>
                                        Currency pairing CFDs enable trade at a fraction of the
                                        trade's total value
                                    </li>
                                    <li>Trade on margin and go long or short</li>
                                </ul>
                                <a href="#" className="btn btn-alt">
                                    Read More
                                </a>
                            </div>
                        </div>
                        <div className="col-md-6 col-md-offset-1">
                            <div className="video-block round">
                                <img
                                    src={require("../../assets/images/video-md-a.jpg")}
                                    alt="CryptoCoin Overview"
                                    className="img-shadow"
                                />
                                <a
                                    href="https://www.youtube.com/watch?v=N6NscwzbMvI"
                                    className="video-play"
                                >
                                    <span className="pe pe-7s-play"></span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/*End Section */}
            <Footer />
        </div>
    );
};

export default Forex;
